/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    /// is onscreen function
    $.fn.isOnScreen = function () {

        var win = $(window);

        var viewport = {
            top: win.scrollTop(),
            left: win.scrollLeft()
        };

        viewport.right = viewport.left + win.width();
        viewport.bottom = viewport.top + win.height();

        var bounds = this.offset();
        bounds.right = bounds.left + this.outerWidth();
        bounds.bottom = bounds.top + this.outerHeight();

        return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

    };

    /// load foundation
    $(document).foundation();

    /// Scroll animations
    var scrollTimeout;
    var throttle = 50;
    $(window).on('scroll', function () {
        var scroll = $(this).scrollTop();

        if(scroll > 60) {
            $('.header').addClass('scroll');
        } else {
            $('.header').removeClass('scroll');
        }

        $('.scrollDiv').each(function(){
          if($(this).isOnScreen()) {
              scrollDistance = $(this).attr('data-scroll');
              scrollDiv = (scrollDistance / $(window).outerHeight()) * ($(this).offset().top - scroll);

              if(scrollDiv < scrollDistance) {
                  $(this).css('transform', 'translate3d(0px, '+ scrollDiv +'px, 0px)')
              }
          }
        });

        if (!scrollTimeout) {
            scrollTimeout = setTimeout(function () {
                var st = $(this).scrollTop();

                checkDivs();

                scrollTimeout = null;
            }, throttle);
        }

        lazy();
    });

    function lazy() {
        $('img.lazy').each(function () {
            if ($(this).isOnScreen()) {
                $(this).attr('src', $(this).attr('data-src'));
                $(this).removeClass('lazy');

                if ($(this).parent().hasClass('liquid')) {
                    $(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
                }
            }
        });
    }
    lazy();


    $('.pushy-content .menu-item-has-children a').click(function(e){
      e.preventDefault();
      var page = $(this).attr('href');
      
      if($(this).parent().hasClass('open') == true || $(this).parent().parent().hasClass('sub-menu') == true) {
        window.location.href = page;
      }

      $(this).parent().toggleClass('open');
    });

    var checkDivs = function () {
        $('.anim.start').each(function () {
            if ($(this).isOnScreen() === true) {
                var anim = $(this).attr('data-anim');
                var speed = $(this).attr('data-speed');
                var delay = $(this).attr('data-delay');

                if (speed === null) {
                    speed = 500;
                }

                if (anim === 'fadeUp') {
                    $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeDown') {
                    $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeLeft') {
                    $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeRight') {
                    $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
                }

                if (anim === 'fadeIn') {
                    $(this).velocity({opacity: 0}, {duration: 0, delay: 0});
                    $(this).removeClass('start').addClass('finish');
                    $(this).velocity({opacity: 1}, {duration: speed, delay: delay});
                }

            }
        });
    }; $(window).scroll();

    $('.anim').each(function () {
        $(this).addClass('start').css('opacity', 0);
    });

    $('.liquid').imgLiquid();

    $('.sectoren .sectoren_slider').slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      prevArrow: $('.sector-prev'),
      nextArrow: $('.sector-next'),
      autoplaySpeed: 3000,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });

    $('.sectoren .diensten_slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      prevArrow: $('.sector-prev'),
      nextArrow: $('.sector-next'),
      autoplaySpeed: 3000,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });

    $('.quotes .row').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true
    });

    $('.partners-slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.partners .partner-slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      autoplay: true,
      prevArrow: $('.sector-prev'),
      nextArrow: $('.sector-next'),
      autoplaySpeed: 3000,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
    });

    $('.pages .page-block .inner').matchHeight();
    $('.services h3').matchHeight();
    $('section.sectoren h4').matchHeight();

    $('.pages .page-block p').matchHeight();
    $('.pages .page-block h4').matchHeight();

    $('.progress-pie-chart').each(function(){
        var $ppc = $(this),
            percent = parseInt($ppc.data('percent')),
            deg = 360*percent/100;
        
        if (percent > 50) {
          $ppc.addClass('gt-50');
        }

        $(this).find('.ppc-progress-fill').css('transform','rotate('+ deg +'deg)');
        $(this).find('.ppc-percents span').html(percent+'%');
    });

    function isEmail(email) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    }

    $('.form button').click(function(){
        var obj = $(this); 
        var mail = obj.parent().find('input[name="mail"]');
        var mailVal = mail.val();
        var phoneField = obj.parent().find('input[name="phone"]');
        var phoneVal = obj.parent().find('input[name="phone"]').val();
        var ajaxUrl = obj.attr('data-ajax');
        var page = obj.attr('data-page');
        var pageID = obj.attr('data-id');
        var agree = obj.parent().find('input[name="agree"]').is(":checked");
        var nameVal = obj.parent().find('input[name="name"]').val();
        var company = obj.parent().find('input[name="company"]').val();

        console.log(agree);

        if(isEmail(mailVal) == true && phoneVal.length > 0 && agree) {
            mail.removeClass('error');
            phoneField.removeClass('error');
            obj.parent().parent().find('.form-loader').show();
            obj.parent().hide();
            obj.parent().parent().find('.text').hide();

            $.ajax({
                type: "POST",
                url: ajaxUrl + '/ajax/form.php',
                data: {
                  mail: mailVal,
                  phoneValue: phoneVal,
                  nameval: nameVal,
                  company: company,
                  page: page,
                  pageID: pageID
                },                
                success: function(val){
                    if(val == 'true') {
                        obj.parent().parent().find('.form-loader').hide();
                        obj.parent().parent().find('.text_after').show();
                    } else {
                        obj.parent().parent().find('.form-loader').hide();
                        obj.parent().show();
                        obj.parent().parent().find('.text').show();
                    }
                },
                error: function(e) {
                  console.log(e);
                }
            });

        } else {

            if(!agree){
                Swal.fire(
                    'Oeps',
                    'Het akkoord gaan met onze privacyvoorwaarden is verplicht.',
                    'error'
                )
            }

            if(isEmail(mailVal) == false) {
              mail.addClass('error');
            } 

            if(phoneVal.length == false) {
              phone.addClass('error');
            } 
        }
    });

    if (undefined !== sessionStorage.hidepass && sessionStorage.hidepass.length) {
      $('.password-overlay').remove();
    }

    $('.password-overlay .button').click(function(){
      var pass = $('.password-overlay').attr('data-pass');
      var val = $('.password-overlay').find('input').val();
      
      if(pass == val) {
        $('.password-overlay').fadeOut();
        sessionStorage.setItem("hidepass", true);
      }
    });

    $('.accordion-item .title').click(function(){
      $('.accordion-item').removeClass('open');
      $(this).parent().addClass('open');
    });

    $('.opleveren .btn').click(function(){
      var cur = $(this).attr('data-title');

      $('.opleveren .btn').removeClass('active');
      $(this).addClass('active');

      $('.item_wrap').hide();
      $('.item_wrap[data-title="'+ cur +'"]').show();
    });

})(jQuery); // Fully reference jQuery after this point.